import ApartmentsOverviewCard from './ApartmentsOverviewCard';

export default ApartmentsOverviewCard;
